import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { UserService } from 'src/app/services/user-service/userservice';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { catchError, takeUntil } from 'rxjs/operators';
import { Observable, of, timer, forkJoin, Subject } from 'rxjs';


@Component({
    selector: 'app-product-lizenz-screen',
    templateUrl: './product-lizenz-screen.component.html',
    styleUrls: ['./product-lizenz-screen.component.scss'],
    standalone: false
})
export class ProductLizenzScreenComponent implements OnInit {
  public product: ProductInterface;
  public editable: boolean = true;
  public loading: any = false;
  public selectedProductId: any;
  public activeOrg: any;
  public productFromListing: any[] = [];
  public selectedGrantOptions: string = "";
  public activeListing: any;
  public ProductsToShow;
  public isPrioritized: boolean = false;
  private destroy$ = new Subject<void>();

  constructor(
    private productService: ProductService,
    private authService: AuthService,
    private dialogService: DialogService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private organisationService: OrganisationService,
    private titleService: Title,
    public headerService: HeaderServiceService,
    private stripeService: StripeService
  ) {
    if (!this.userService.currentMemberships.find((orga) =>
      orga.organisationId ===
      this.organisationService.activeItem.organisationId
    )) {
      this.router.navigateByUrl('/marktplatz');
    }
  }

  // intialize() {
  //   this.productFromListing = this.loadProductsList();
  // }

  // intializeAndUpdate() {
  //   this.productFromListing = this.loadAndUpdateProductsList();
  // }

  async ngOnInit() {
    this.loading = true;
    this.activeOrg = this.headerService.activeOrganisation.organisationId;
    this.product = this.productService.activeProduct;
    this.selectedProductId = this.product.id;
    const name = this.product.name;
    await this.stripeService.loadProducts();
    this.loadProducts();
    this.titleService.setTitle(
      name + ': Lizenzieren des Produkt - BIMSWARM'
    );
    this.loadProductsList();

  }

  onSave() {
    if (this.selectedGrantOptions.length === 0) {
      this.dialogService.openDialog(
        'Lizenzierung Fehlgeschlagen',
        'Bitte wählen Sie mindestens einen Authorization Abonnement aus der Liste aus.'
      );
      return;
    }
    else {
      this.dialogService
        .openConfirmDialog(
          'Möchten Sie dieses Produkt wirklich diesem Abonnement zuordnen?',
          'Abbrechen',
          'Bestätigen')
        .subscribe((confirmed) => {
          if (confirmed) {
            if (this.activeListing && this.activeListing.originListing.subscriptionId) {
              this.removeEntryAndAddEntry();
            }
            else {
              this.addOneEntry();
            }
          }
          else if (!confirmed) {
            this.loading = false;
            this.cdr.markForCheck();
            this.cdr.detectChanges();
          }
        });
    }
  }

  onCancel() {
    const productId = this.product.id;
    const organisationId = this.product.company;
    this.router.navigate([
      'organisations',
      organisationId,
      'products',
      productId
    ]);
  }

  onGrantSelection(selected: string) {
    this.selectedGrantOptions = selected;
  }


  loadProductsList(): void {
    this.loading = true;
    this.stripeService.getAllListingProductFromOrgId(this.activeOrg)
      .pipe(
        catchError(error => {
          this.loading = false;
          this.cdr.markForCheck();
          return of([]);
        })
      )
      .subscribe((data: any[]) => {
        this.loading = false;
        const productId = String(this.selectedProductId);

        const matchingIndex = data.findIndex(item =>
          Array.isArray(item.originListing?.products) && item.originListing.products.some(id => String(id) === productId)
        );
        if (matchingIndex !== -1) {
          this.activeListing = data[matchingIndex];
          this.isPrioritized = this.isProductPrioritized();
          const filteredData = data
            .filter((_, index) => index !== matchingIndex)
            .filter(item => item.originListing?.currentUsage < item.originListing?.listingCapacity);
          this.productFromListing = filteredData.sort((a, b) => b.originListing.id - a.originListing.id);

          this.product.listingPkgName = this.activeListing.originListing.packageName;
          // return filteredData;
        } else {
          this.activeListing = null;
          // return data;
          this.productFromListing = data
            .filter(item => item.originListing?.currentUsage < item.originListing?.listingCapacity)
            .sort((a, b) => b.originListing.id - a.originListing.id);
        }
        this.cdr.markForCheck();
        this.cdr.detectChanges();

      });
  }

  // loadAndUpdateProductsList(): void{
  //   this.loading = true;
  //   this.stripeService.getAllListingProductFromOrgId(this.activeOrg)
  //     .pipe(
  //       catchError(error => {
  //         console.error('Error loading abonnements list:', error);
  //         this.loading = false;
  //         this.cdr.markForCheck();
  //         return of([]);
  //       })
  //     )
  //     .subscribe((data: any[]) => {
  //           this.loading = false;
  //           const productId = String(this.selectedProductId);
  //           const matchingIndex = data.findIndex(item =>
  //                 Array.isArray(item.originListing?.products) && item.originListing.products.some(id => String(id) === productId)
  //           );
  //           if (matchingIndex !== -1) {
  //               this.activeListing = data[matchingIndex];
  //               const filteredData = data.filter((_, index) => index !== matchingIndex);
  //               this.productFromListing = filteredData.sort((a, b) => b.originListing.id - a.originListing.id);
  //               this.product.listingPkgName = this.activeListing.originListing.packageName;
  //               var product = this.productService.editProduct(this.product);
  //               // return filteredData;
  //           } else {
  //             this.activeListing = null;
  //             this.productFromListing = data.sort((a, b) => b.originListing.id - a.originListing.id);
  //             // return data;
  //           }
  //           this.cdr.markForCheck();
  //           this.cdr.detectChanges();

  //     });
  // }

  addOneEntry(): any {
    this.loading = true;
    if (this.selectedProductId && this.selectedGrantOptions) {
      this.stripeService.addProductsToListing(this.activeOrg, this.selectedGrantOptions, this.selectedProductId)
        .pipe(catchError(error => { return of("0"); }))
        .subscribe(data => {
          this.loading = false;
          this.cdr.markForCheck();
          this.cdr.detectChanges();

          if (data.status == 403 || data.status == 404 || data.status == 226 || data.status == 500) {
            this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Fehler beim  Zuordnung eines Produkts zu einem Abonnement,');
            return;
          }
          if (data.status == 226) {
            this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Dieses Abonnement ist voll');
            return;
          } else {
            // if(data.status == 200) {
            const subPackage = this.productFromListing.find(
              (entry) => entry.originListing.subscriptionId === this.selectedGrantOptions);

            if (subPackage?.prioListing && subPackage.prioListing.currentUsage < subPackage.prioListing.listingCapacity) {
              this.askAndHandlePrioritization(this.selectedProductId);
            } else {
              this.dialogService.openDialog(
                'Produkt lizenziert',
                'Ihr Produkt ist nun mit einem neuen Abonnement lizenziert und veröffentlicht.'
              );
              this.loadProductsList();
              // this.loadAndUpdateProductsList();
            }
            // this.intializeAndUpdate();
          }
        });
    }
  }

  removeEntry(): any {
    this.loading = true;
    this.stripeService.removeProductFromListing(this.activeOrg, this.activeListing.originListing.subscriptionId, this.selectedProductId)
      .pipe(catchError(error => { return of("0"); }))
      .subscribe(data => {
        this.loading = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        if (data.status == 403 || data.status == 404 || data.status == 500) {
          this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Fehler beim  Zuordnung eines Produkts zu einem Abonnement,');
        }
        else if (data) {
          this.dialogService.openDialog('Produkt ist nicht mehr lizenziert', 'Ihr Produkt ist nun nicht mehr für Ihr Abonnement lizenziert und wird vom Marktplatz entfernt.');
          if (this.isProductPrioritized()) {
            this.stripeService.prioritizeProduct(this.activeOrg, this.selectedGrantOptions, this.selectedProductId.toString(), false)
              .subscribe((prioritizeResponse) => {
                this.loadProductsList();
                // this.loadAndUpdateProductsList();
                // this.intializeAndUpdate();
              });
          } else {
            this.loadProductsList();
          }
        }
      });
  }

  removeEntryAndAddEntry(): any {
    this.loading = true;
    this.stripeService.removeProductFromListing(this.activeOrg, this.activeListing.originListing.subscriptionId, this.selectedProductId)
      .pipe(catchError(error => { return of("0"); }))
      .subscribe(data => {
        this.loading = false;
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        if (data.status == 403 || data.status == 404 || data.status == 500) {
          this.dialogService.openDialog('Die Zuordnung dieses Produkts zu diesem Abonnement ist fehlgeschlagen.', 'Fehler beim  Zuordnung eines Produkts zu einem Abonnement,');
        }
        else if (data) {
          if (this.isProductPrioritized()) {
            this.stripeService.prioritizeProduct(this.activeOrg, this.activeListing.originListing.subscriptionId, this.selectedProductId.toString(), false)
              .subscribe((prioritizeResponse) => { });
          }
          this.addOneEntry();
        }
      });
  }

  removePriorization(subscribtionId: string): void {
    this.loading = true;
    this.stripeService.prioritizeProduct(this.activeOrg, subscribtionId, this.selectedProductId.toString(), false)
      .pipe(
        catchError(error => {
          this.dialogService.openDialog('Depriorisierung fehlgeschlagen', 'Es ist ein Fehler aufgetreten...');
          this.loading = false;
          this.cdr.markForCheck();
          return of(null);
        })
      )
      .subscribe((prioritizeResponse) => {
        this.loading = false;
        this.cdr.markForCheck();
        if (prioritizeResponse === null) return;
        if (prioritizeResponse?.status !== 200) {
          this.dialogService.openDialog(
            'Priorisierung fehlgeschlagen',
            'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
          );
        } else {
          this.dialogService.openDialog('Produkt depriorisiert', '');
          this.loadProductsList();
          // this.loadAndUpdateProductsList();
        }
      });
  }

  addPriorization(subscribtionId: string): void {
    this.loading = true;
    this.stripeService.prioritizeProduct(this.activeOrg, subscribtionId, this.selectedProductId.toString(), true)
      .pipe(
        catchError(error => {
          this.dialogService.openDialog('Priorisierung fehlgeschlagen', 'Es ist ein Fehler aufgetreten...');
          this.loading = false;
          this.cdr.markForCheck();
          return of(null);
        })
      )
      .subscribe((prioritizeResponse) => {
        this.loading = false;
        this.cdr.markForCheck();
        if (prioritizeResponse === null) return;
        if (prioritizeResponse?.status !== 200) {
          this.dialogService.openDialog(
            'Priorisierung fehlgeschlagen',
            'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
          );
        } else {
          this.dialogService.openDialog('Produkt priorisiert', '');
          this.loadProductsList();
          // this.loadAndUpdateProductsList();
        }
      });
  }

  public showTarifeSelectionDialog() {
    this.dialogService.openTarifeSelectionDialog('', '', this.ProductsToShow)
      .subscribe((result) => {
        if (result) {
          this.loadProductsList();
          // this.loadAndUpdateProductsList();
          // this.intializeAndUpdate();
        }
      });
  }

  private loadProducts(): void {
    this.stripeService.ProductsToShowObservable
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(products => {
        this.ProductsToShow = products;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private askAndHandlePrioritization(productId: number): void {
    this.dialogService.openConfirmDialog(
      'Produkt lizenziert',
      'Nein',
      'Ja',
      'Möchten Sie das Produkt entsprechend Ihrem Tarif priorisieren?'
    ).subscribe((result) => {
      if (result) {
        this.loading = true;
        this.stripeService.prioritizeProduct(this.activeOrg, this.selectedGrantOptions, productId.toString(), true)
          .pipe(
            catchError(error => {
              this.loading = false;
              this.cdr.markForCheck();
              return of(null);
            })
          )
          .subscribe((prioritizeResponse) => {
            this.loading = false;
            this.cdr.markForCheck();
            // Add more status checks!!!
            if (prioritizeResponse === null) return;
            if (prioritizeResponse?.status !== 200) {
              this.dialogService.openDialog(
                'Priorisierung fehlgeschlagen',
                'Die Priorisierung ist fehlgeschlagen. Bitte versuchen Sie es später erneut.'
              );
            } else {
              this.dialogService.openDialog('Produkt priorisiert', '');
              this.loadProductsList();
              // this.loadAndUpdateProductsList();
            }
          });
      }
    });
  }

  isProductPrioritized(): boolean {
    const productId = String(this.selectedProductId);
    const prioProducts = this.activeListing?.prioListing?.products ?? [];
    return prioProducts.includes(productId);
  }
}
